import { createApp } from 'vue';
import App from './App.vue';
import './assets/custom.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { VueReCaptcha } from 'vue-recaptcha-v3';

const app = createApp(App);
app.component('VueReCaptcha', VueReCaptcha);
app.mount('#app');
